/* Read authoritative cart state from drawer HTML without a separate cart JSON read. */
(() => {
  function prepareSections() {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections }
    }));
    return [...new Set(sections)];
  }

  async function getCart(response, requestedSections = []) {
    const sections = { ...Object.fromEntries(requestedSections.map(id => [id, null])), ...response.sections };
    // Shopify can accept an add while returning null for a failed section render.
    // Recover the display only; never repeat the cart mutation.
    const missing = Object.keys(sections).filter(id => !sections[id]);
    if (missing.length) {
      const refreshed = await fetch(`${Shopify.routes.root}cart?sections=${encodeURIComponent(missing.join(','))}`);
      if (!refreshed.ok) throw new Error('Unable to refresh the cart.');
      Object.assign(sections, await refreshed.json());
      if (missing.some(id => !sections[id])) throw new Error('Unable to refresh the cart.');
    }
    for (const html of Object.values(sections)) {
      const state = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-state]');
      if (!state) continue;
      try {
        const cart = JSON.parse(state.textContent);
        if (Number.isInteger(cart.item_count) && Array.isArray(cart.items)) return { ...cart, sections };
      } catch (_) {
        // Retain compatibility with older drawer HTML during theme updates.
      }
    }
    const refreshed = await fetch(`${Shopify.routes.root}cart.js`);
    if (!refreshed.ok) throw new Error('Unable to refresh the cart.');
    return { ...await refreshed.json(), sections };
  }

  function notifyAdded(form, response, cart, onSuccessDo) {
    form.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      detail: { items: response.items || [response], cart, onSuccessDo }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo, cart }
    }));
  }

  window.loulouCart = { prepareSections, getCart, notifyAdded };
})();
